import * as yup from 'yup';
import { MAX_TITLE_LENGTH } from '../isValidFolderName';

// Yup schema for gallection folders rename request validation
const gallectionFoldersRenameValidationSchema = yup.object({
  type: yup
    .string()
    .oneOf(['gallery', 'collection', 'stash', 'private_collection'], 'Invalid type')
    .required('Type is required'),
  username: yup.string().optional(),
  folderid: yup
    .number()
    .integer('Folder ID must be an integer')
    .required('Folder ID is required'),
  name: yup
    .string()
    .required('Name is required')
    .max(MAX_TITLE_LENGTH, `Name cannot exceed ${MAX_TITLE_LENGTH} characters`)
    .test('max-bytes', `Exceeds byte limit of ${MAX_TITLE_LENGTH}`, value => {
      if (!value) return true;
      return new Blob([value]).size <= MAX_TITLE_LENGTH;
    })
    .matches(/^[ \w$?:.,'"\-+]+$/, 'Name contains invalid characters'),
});

/**
 * Validates gallection folders rename request data using Yup schema
 * Based on papiRequestDaSharedGallectionFoldersRenameSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateGallectionFoldersRenameRequest(data: any): boolean {
  try {
    gallectionFoldersRenameValidationSchema.validateSync(data, { abortEarly: false });
    return true;
  } catch (error) {
    return false;
  }
}
